const getTime = (date) => {
  return new Date(date).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: 'numeric',
  });
};

export default getTime;
